import React, { useState } from 'react';
// import { useRef } from 'react';
import './Signature.css';

// const kotwarRef = useRef();

const Signature = () => {
  const [signatures] = useState([
    'हस्ताक्षर कोटवार',
    'हस्ताक्षर सरपंच',
    'हस्ताक्षर पटवारी',
  ]);

  // const handleSignatureChange = (index, e) => {
  //   const updatedSignatures = [...signatures];
  //   updatedSignatures[index] = e.target.value;
  //   setSignatures(updatedSignatures);
  // };

  return (
    <div className="signatureDiv">
      {signatures.map((signature, index) => (
        <p
          key={index + Math.random()}
          className="input"
          // type="text"
          // placeholder={`Signature ${index + 1}`}
          // value={signature}
          // onChange={e => handleSignatureChange(index, e)}
          // onPointerLeave={window.alert('hello')}
        >
          {signature}
        </p>
      ))}
    </div>
  );
};

export default Signature;
